import Common from './common';
import User from './user';
import Job from './job';
import { combineReducers } from 'redux';
import JobFilterReducer from './jobFilter';
import JobInfoReducer from './jobInfo';

export default combineReducers({
    Common,
    User,
    Job,
    jobFilter: JobFilterReducer,
    jobInfo: JobInfoReducer
});